class SplideCarousel {
  constructor(element) {
    this.element = element;
  }

  splideSettings() {
    const elms = document.getElementsByClassName('splide');
    const processedIDs = new Set();

    for (let i = 0; i < elms.length; i++) {
      const splide = new Splide(elms[i]);
      const carouselID = splide.root.id;

      if (processedIDs.has(carouselID)) {
        continue;
      }

      const noAutoScrollIDs = [
        'featured-media-slider',
        'featured-ambassador-slider',
        'featured-case-studies-slider',
        'product-main-slider',
        'product-thumbnail-slider',
      ];

      const btnPrev = splide.root.querySelector('.custom-splide__arrow--prev');
      const btnNext = splide.root.querySelector('.custom-splide__arrow--next');

      // Handle product gallery sync
      if (carouselID === 'product-main-slider') {
        const thumbnailSlider = document.querySelector('#product-thumbnail-slider');

        if (thumbnailSlider) {
          const thumbnails = new Splide(thumbnailSlider);

          splide.sync(thumbnails);

          splide.mount();
          thumbnails.mount();

          processedIDs.add('product-main-slider');
          processedIDs.add('product-thumbnail-slider');
        } else {
          splide.mount();
          processedIDs.add(carouselID);
        }
      }
      else if (carouselID === 'product-thumbnail-slider') {
        if (!processedIDs.has(carouselID)) {
          splide.mount();
          processedIDs.add(carouselID);
        }
        continue;
      }
      else if (noAutoScrollIDs.includes(carouselID)) {
        splide.mount();
        processedIDs.add(carouselID);

        if (btnPrev && btnNext) {
          btnPrev.addEventListener('click', () => splide.go('<'));
          btnNext.addEventListener('click', () => splide.go('>'));
        }
      }
      else {
        const { AutoScroll } = window.splide.Extensions;
        splide.mount({ AutoScroll });
        processedIDs.add(carouselID);
      }
    }
  }

  fireWhenReady(func) {
    return document.addEventListener('DOMContentLoaded', func);
  }

  init() {
    this.fireWhenReady(this.splideSettings.bind(this));
  }
}

export default SplideCarousel;
